import { createFileRoute } from "@tanstack/react-router";
import { SynergyView } from "../../components/synergy";

export const Route = createFileRoute("/synergy/")({
    component: SynergyView,
});
